import config from './config';
import layers from './layers';
import paymentDetails from './paymentDetails';
import paymentUserData from './paymentUserData';
import activationInit from './activationInit';
import registrationUserData from './registrationUserData';
import changePin from './changePin';
import buyWithInstacred from './buyWithInstacred';
import bicConfig from './bicConfig';
import ntbConfig from './ntbActivation';
import userDetails from './userDetails';
import userLogin from './userLogin';
import widgetData from './widgetData';
import modal from './modal';
import identifyUser from './identifyUser';
import programPageData from './programPage';
import odr from './odr';
import navBarConfig from './navBarConfig';
import ntbFlow from './ntbFlow';

export default {
  config,
  paymentDetails,
  paymentUserData,
  activationInit,
  registrationUserData,
  changePin,
  buyWithInstacred,
  bicConfig,
  layers,
  userDetails,
  userLogin,
  ntbConfig,
  widgetData,
  modal,
  identifyUser,
  programPageData,
  odr,
  navBarConfig,
  ntbFlow,
};



// WEBPACK FOOTER //
// ./reducer/index.js